import React from "react";

const AccountSettingIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_644_136)">
        <path
          d="M11.6667 9.16667H17.5V5H11.6667V9.16667ZM14.5833 8.125L12.5 6.66667V5.83333L14.5833 7.29167L16.6667 5.83333V6.66667L14.5833 8.125ZM1.66667 17.5C1.20833 17.5 0.815972 17.3368 0.489583 17.0104C0.163194 16.684 0 16.2917 0 15.8333V4.16667C0 3.70833 0.163194 3.31597 0.489583 2.98958C0.815972 2.66319 1.20833 2.5 1.66667 2.5H18.3333C18.7917 2.5 19.184 2.66319 19.5104 2.98958C19.8368 3.31597 20 3.70833 20 4.16667V15.8333C20 16.2917 19.8368 16.684 19.5104 17.0104C19.184 17.3368 18.7917 17.5 18.3333 17.5H1.66667ZM7.5 11.6667C8.19444 11.6667 8.78472 11.4236 9.27083 10.9375C9.75694 10.4514 10 9.86111 10 9.16667C10 8.47222 9.75694 7.88194 9.27083 7.39583C8.78472 6.90972 8.19444 6.66667 7.5 6.66667C6.80556 6.66667 6.21528 6.90972 5.72917 7.39583C5.24306 7.88194 5 8.47222 5 9.16667C5 9.86111 5.24306 10.4514 5.72917 10.9375C6.21528 11.4236 6.80556 11.6667 7.5 11.6667ZM1.75 15.8333H13.25C12.6667 14.7917 11.8611 13.9757 10.8333 13.3854C9.80556 12.7951 8.69444 12.5 7.5 12.5C6.30556 12.5 5.19444 12.7951 4.16667 13.3854C3.13889 13.9757 2.33333 14.7917 1.75 15.8333Z"
          fill="#2B2B2B"
        />
      </g>
      <defs>
        <clipPath id="clip0_644_136">
          <rect width="20" height="20" fill="#2B2B2B" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AccountSettingIcon;
